import { Splide } from "@splidejs/splide";

export class Polaroids {
  constructor() {
    this.init();
  }

  init() {
    const polaroidsWrappers = document.querySelectorAll(".polaroids.splide");

    polaroidsWrappers.forEach((polaroidsWrapper) => {
      this.createPolaroid(polaroidsWrapper);
    });
  }

  createPolaroid(polaroidsWrapper) {
    const arrowLeft = polaroidsWrapper.querySelector(".polaroids__arrow--prev");
    const arrowRight = polaroidsWrapper.querySelector(
      ".polaroids__arrow--next"
    );
    const indexCurrent = polaroidsWrapper.querySelector(".polaroids__current");
    const items = polaroidsWrapper.querySelectorAll(".polaroids__item");

    const i18n = this.getI18nConfig();

    const splide = new Splide(polaroidsWrapper, {
      type: "loop",
      perPage: 3,
      perMove: 1,
      pagination: false,
      arrows: false,
      gap: "1.5rem",
      focus: "center",
      flickMaxPages: 0.3,
      keyboard: "focused",
      updateOnMove: true,
      breakpoints: {
        1000: {
          gap: 0,
          perPage: 1.5,
        },
      },
      dragMinThreshold: {
        mouse: 0,
        touch: 10,
      },
      i18n,
    });

    this.setupPolaroidEvents(splide, arrowLeft, arrowRight, indexCurrent);
    splide.mount();
  }

  setupPolaroidEvents(splide, arrowLeft, arrowRight, indexCurrent) {
    // Update the current index
    if (indexCurrent) {
      splide.on("move", () => {
        indexCurrent.innerHTML = splide.index + 1;
      });
    }

    // Setup arrow navigation
    if (arrowLeft) {
      arrowLeft.addEventListener("click", () => {
        splide.go("<");
      });
    }

    if (arrowRight) {
      arrowRight.addEventListener("click", () => {
        splide.go(">");
      });
    }

    // Setup click navigation
    splide.on("click", (event) => {
      splide.go(event.index);
    });
  }

  getI18nConfig() {
    const isEnglish = document.documentElement.lang === "en";

    return isEnglish
      ? {
          prev: "Previous Polaroid",
          next: "Next Polaroid",
          carousel: "Polaroids",
          slide: "Polaroid",
          slideLabel: "%s of %s",
        }
      : {
          prev: "Vorheriges Polaroid",
          next: "Nächstes Polaroid",
          carousel: "Polaroids",
          slide: "Polaroid",
          slideLabel: "%s von %s",
        };
  }
}
